import { render, staticRenderFns } from "./GroupTransactionRecordInfo.vue?vue&type=template&id=4ab1694c&"
import script from "./GroupTransactionRecordInfo.vue?vue&type=script&lang=js&"
export * from "./GroupTransactionRecordInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupTransactionRecordInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports